import { OFFICES_ACTIONS } from "constants/Actions/Offices";

// Estado inicial del reducer
const aInitialState = {
    aOffices: [],
    aActiveUserOffices: [],
    nTotalPages: null,
    oOffice: null,
    aOfficesSuggestion: [],

    bIsSuccess: false,
    nNewId: null,
    bIsError: false,
    bIsDelete: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a las oficinas almacenadas en el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const OfficeReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case OFFICES_ACTIONS.GET_ALL_OFFICES:
            return { ...aState, aOffices: oAction.data };
        case OFFICES_ACTIONS.GET_USER_ACTIVE_OFFICES:
            return { ...aState, aActiveUserOffices: oAction.data };
        case OFFICES_ACTIONS.SUGGESTION:
            return { ...aState, aOfficesSuggestion: oAction.data };
        case OFFICES_ACTIONS.FIND:
            return { ...aState, oOffice: oAction.data };
        case OFFICES_ACTIONS.DELETE:
            return { ...aState, bIsDelete: true };
        case OFFICES_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true, nNewId: oAction.data };
        case OFFICES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case OFFICES_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, bIsDelete: false, nNewId: null, oOffice: null };
        case OFFICES_ACTIONS.RESET:
            return { ...aState, bIsSuccess: false, bIsError: false, bIsDelete: false, nNewId: null };
        case OFFICES_ACTIONS.CLEAN_USER_ACTIVE_OFFICES:
            return { ...aState, aActiveUserOffices: [] }
        default:
            return aState;
    }
}
